import React from 'react';
import { Card, Icon } from 'ui';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import MediaPlayer from 'components/ui/MediaPlayer';

import AskForFeedback from './AskForFeedback';

const PreviewModal = ({
  handleDismiss,
  show,
  attempt,
  prompt,
  canRequestFeedback,
  hasZiggeoForAllMedia = false,
  ziggeoApiKey,
}) => {
  return (
    show && (
      <RenderInBody>
        <ModalContainer
          className="ModalTakeover-background Modal-background"
          onEscape={handleDismiss}
        >
          <div
            className="PreviousAttempt-modal ModalTakeover-container"
            role="button"
            tabIndex="0"
          >
            <div
              className="ModalTakeover-closeButton"
              onClick={handleDismiss}
              onKeyDown={e => e.key === 'Enter' && handleDismiss()}
              role="button"
              tabIndex="0"
            >
              <Icon name="error" />
            </div>
            <Card>
              <Card.Content>
                <div className="VideoEmbed VideoEmbed-player VideoEmbed--background">
                  <MediaPlayer
                    recording={attempt.recording}
                    ziggeoApiKey={ziggeoApiKey}
                    hasZiggeoForAllMedia={hasZiggeoForAllMedia}
                  />
                </div>
              </Card.Content>
              <AskForFeedback
                scenarioId={attempt.scenarioId}
                attempt={attempt}
                prompt={prompt}
                canRequestFeedback={canRequestFeedback}
              />
            </Card>
          </div>
        </ModalContainer>
      </RenderInBody>
    )
  );
};

export default PreviewModal;
